import { getProfile } from "../../api/profile.service";
import { setProfile } from "../actions/userProfileActions";
import auth from "../../utils/auth";

export const fetchProfile = (token: string) => {
  return (dispatch) => {
    getProfile(token).then(({ data }) => {
      if (data?.userId) localStorage.setItem("userId", data?.userId);
      dispatch(setProfile(data));
    });
  };
};

export const logout = () => {
  return (dispatch) => {
    auth.logout();
    dispatch(setProfile(null));
  };
};
